module.exports = __webpack_public_path__ + "img/Elecocite_120X35.3fd272ca.png";